import { useMutation } from '@tanstack/react-query';
import { GET, GET_BARCORE_AND_QRCODE, GET_VERIFY_QRCODE } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';
import { navigateTo } from '../../../utils/navigation';
import { ROUTES_PATH } from '../../../resources/routes-name';
import { useDispatch } from 'react-redux';
import { setRegisterProductData } from '../../../redux/registerProduct/action';

export const useBarcodeQuery = ({ reset, getValues }) => {
  const dispatch = useDispatch();
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ warrantyNumberCode, barcode }) => {
      const response = await GET(GET_BARCORE_AND_QRCODE(warrantyNumberCode, barcode));
      if (response.result.item.allowWarranty !== 'ACTIVE') {
        throw new Error('สินค้านี้ไม่เปิดให้ลงทะเบียนรับประกันสินค้า');
      }
      return response.result;
    },
    onSuccess: (result) => {
      openAlert({
        type: 'success',
        model: 'message',
        message: 'สินค้าถูกต้อง',
      });
      dispatch(
        setRegisterProductData({
          ...result,
        }),
      );
      setTimeout(() => {
        const warrantyNumberCode = result?.warranty?.warrantyNumberCode;
        navigateTo({
          pathname: ROUTES_PATH.ROUTE_REGISTER_PRODUCT.PATH,
          search: warrantyNumberCode ? `?warrantyNumberCode=${warrantyNumberCode}` : undefined,
        });
      }, 1000);
    },
    onError: (result) => {
      logger.error('Error verifying barcode:', result);
      openAlert({
        type: 'error',
        model: 'message',
        message: result.message || 'เกิดข้อผิดพลาดในการตรวจสอบสินค้า',
      });
      reset({
        ...getValues(),
        ...result,
      });
    },
  });
  return { mutate, loading: isPending };
};

export const useVerifyQRCode = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (warrantyNumberCode) => {
      const apiPath = GET_VERIFY_QRCODE(warrantyNumberCode);
      const response = await GET(apiPath);
      return response;
    },
  });

  // Wrapper to support custom callbacks
  const mutateWithCallback = (warrantyNumberCode, options = {}) => {
    mutate(warrantyNumberCode, {
      onSuccess: (response) => {
        // Call default onSuccess behavior
        openAlert({
          type: 'success',
          message: 'QR Code รับประกันถูกต้อง',
        });
        // Call custom callback if provided
        if (options.onSuccess) {
          options.onSuccess();
        }
      },
      onError: (error) => {
        // Call default onError behavior
        console.error('API Error:', error);
        openAlert({
          type: 'error',
          message: error?.message || 'เกิดข้อผิดพลาดในการตรวจสอบ QR code',
        });

        // Call custom error callback if provided
        if (options.onError) {
          options.onError(error);
        }
      },
    });
  };

  return { mutate: mutateWithCallback, loading: isPending };
};
